function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { AllhomesListingCardAddress, AllhomesListingCardFeatures, AllhomesListingCardImages } from '../../components';
import * as styles from './auction-result-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AuctionResultCard = props => {
  var _props$url, _props$address;
  var _useContext = useContext(MediaContext),
    tablet = _useContext.tablet,
    desktop = _useContext.desktop;
  var isEnabled = !!props.url;
  return ___EmotionJSX("div", {
    css: styles.auctionCard(isEnabled),
    className: props.className,
    id: "".concat(props.id)
  }, ___EmotionJSX("a", {
    css: styles.link(isEnabled),
    href: (_props$url = props.url) !== null && _props$url !== void 0 ? _props$url : undefined,
    onClick: () => {
      if (props.onClick) {
        props.onClick(props.id);
      }
    }
  }, (tablet || desktop) && ___EmotionJSX(AllhomesListingCardImages, _extends({
    css: styles.image,
    isResponsive: false
  }, props.images)), ___EmotionJSX("div", {
    css: styles.detailsBody
  }, ___EmotionJSX("div", {
    css: styles.detailsTop
  }, ___EmotionJSX(AllhomesListingCardAddress, {
    css: styles.address(isEnabled),
    street: (_props$address = props.address) === null || _props$address === void 0 ? void 0 : _props$address.street,
    includeStructuredData: props.includeStructuredData
  }), ___EmotionJSX("div", {
    css: styles.price
  }, props.pricePrefix && ___EmotionJSX("span", {
    css: styles.pricePrefix
  }, props.pricePrefix), ___EmotionJSX("span", null, props.price))), ___EmotionJSX("div", {
    css: styles.detailsBottom
  }, ___EmotionJSX("div", {
    css: styles.detailsBottomLeft
  }, ___EmotionJSX(AllhomesListingCardFeatures, _extends({
    css: styles.features
  }, props.features)), props.propertyType && ___EmotionJSX("div", {
    css: styles.propertyType
  }, props.propertyType)), props.agencyName && ___EmotionJSX("div", {
    css: styles.auctionAgency
  }, props.agencyName)))));
};